module.exports = __webpack_public_path__ + "static/media/ocadoLogo.c90e67d9.png";